module.exports = __webpack_public_path__ + "static/media/truck-couch.9799aed8.svg";